import { render, staticRenderFns } from "./TasksAcceptWindow.vue?vue&type=template&id=eadbdf6c&scoped=true&"
import script from "./TasksAcceptWindow.vue?vue&type=script&lang=js&"
export * from "./TasksAcceptWindow.vue?vue&type=script&lang=js&"
import style0 from "./TasksAcceptWindow.vue?vue&type=style&index=0&id=eadbdf6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadbdf6c",
  null
  
)

export default component.exports
import {QCard,QCardSection,QScrollArea,QSpace,QBtn,QTooltip,QItem,QCheckbox,QIcon,QSlideTransition,QForm,QInput,QExpansionItem,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QScrollArea,QSpace,QBtn,QTooltip,QItem,QCheckbox,QIcon,QSlideTransition,QForm,QInput,QExpansionItem,QSeparator,QCardActions}, component.options.components || {})
